import { Link, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import UserSingleReport from "../../../pages/userSingleReport/userSingleReport";
import SectionContent from "../../../components/sectionContent/sectionContent";
import HeaderBtn from "../../../components/headerBtn/headerBtn";
import Sidebar from "../../../components/sidebar/Sidebar";

import "../../../scss/App.scss";
import { IUserOptions } from "../../../types/interfaces";

import { AppDispatch } from "../../../redux/reducer/store";

import { reducerGetReport } from "../../../redux/reducer/map/reducer/reducerMapsList";
import { useCallback, useEffect, useRef, useState } from "react";

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const AdminSingleReportSection = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { id } = useParams<{ id: string }>();
  const { report } = useSelector(
    (state: any) => state.userSingleReport.userSingleReport
  );

  const [overflowedBtnsCount, setOverflowedBtnsCount] = useState<number>(0);
  const [isOpenGroupBtn, setIsOpenGroupBtn] = useState<boolean>(false);

  const { isOpenSidebar } = useSelector(
    (state: IUserOptions) => state.user.user
  );

  const { claims } = useSelector((state: any) => state.user.user.data);

  const buttonsContainerRef = useRef<HTMLDivElement>(null);
  const headFilterRef = useRef<any>(null);

  const sidebarWidth = isOpenSidebar ? 190 : 44;
  const headerFiltersAndSelectWidth = 525;
  const minEmptyWidthForNewBtn = 300;
  const groupBtnWidth = 70;
  const buttonWidth = 130;

  const availableButtons = [
    {
      component: (
        <HeaderBtn
          content='Настройки'
          purpose='adminSingleReportSettings'
          modalTitle='Настройки'
        />

      ),
    },

    (claims.includes("admin") || claims.includes("reports:copy")) && {
      component: (
        <HeaderBtn
          content="Скопировать отчет"
          purpose="copyReport"
          modalTitle="Скопировать отчет"
        />
      ),
    },

    (claims.includes("admin") || claims.includes("reports:delete")) && {
      component: (
       <HeaderBtn
        content='Удалить отчет'
        purpose='deleteReport'
        modalTitle='Удалить отчет'
      />
      ),
    },

    (claims.includes("admin") || claims.includes("reports:edit")) && {
      component: (
        <HeaderBtn
          content="Удалить фотографии"
          purpose="deletePhotos"
          modalTitle="Подтверждение удаления фотографий"
        />
      ),
    },
  ];

  const filteredAvailableButtons = availableButtons.filter(
    (btn: { component: JSX.Element }) => btn
  );

  useEffect(() => {
    if (
      filteredAvailableButtons.slice(-(overflowedBtnsCount as number)).length +
        filteredAvailableButtons.slice(
          0,
          filteredAvailableButtons.length - overflowedBtnsCount
        ).length >
      filteredAvailableButtons.length
    ) {
      setOverflowedBtnsCount(0);
    }
  }, [filteredAvailableButtons, overflowedBtnsCount]);

  const handleWindowResize = useCallback(() => {
    const allButtonsWidth =
      filteredAvailableButtons.slice(
        0,
        filteredAvailableButtons.length - overflowedBtnsCount
      ).length * buttonWidth;
    const spaceToLeftSideOfFilters =
      headFilterRef.current?.getBoundingClientRect().left;
    const windowWidth = window.innerWidth;
    const isOverflowed = JSON.parse(IS_VISIBLE_SIDEBAR as string)
      ? allButtonsWidth >
        windowWidth - headerFiltersAndSelectWidth - sidebarWidth
      : allButtonsWidth > windowWidth - headerFiltersAndSelectWidth;

    if (isOverflowed) {
      setIsOpenGroupBtn(true);
      setOverflowedBtnsCount((prevValue: number) => {
        if (overflowedBtnsCount === filteredAvailableButtons.length) {
          return prevValue;
        } else {
          return overflowedBtnsCount + 1;
        }
      });
    }
    const isEnoughtSpace = JSON.parse(IS_VISIBLE_SIDEBAR as string)
      ? spaceToLeftSideOfFilters -
          sidebarWidth -
          allButtonsWidth +
          groupBtnWidth >
        minEmptyWidthForNewBtn
      : spaceToLeftSideOfFilters - allButtonsWidth + groupBtnWidth >
        minEmptyWidthForNewBtn;
    if (isEnoughtSpace) {
      setOverflowedBtnsCount((prevValue: number) => {
        if (prevValue <= 1) {
          setIsOpenGroupBtn(false);
          return 0;
        } else return prevValue - 1;
      });
    }
  }, [filteredAvailableButtons, overflowedBtnsCount, sidebarWidth]);

  useEffect(() => {
    handleWindowResize();
    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [handleWindowResize]);

  const displayedAvailableBtns = filteredAvailableButtons
    ?.slice(-(overflowedBtnsCount as number))
    ?.map((elem: { component: JSX.Element }, index: number) => {
      return elem && <div key={index}>{elem?.component}</div>;
    });

  const displayedHeadBtns = filteredAvailableButtons
    ?.slice(0, filteredAvailableButtons.length - overflowedBtnsCount)
    ?.map((elem: { component: JSX.Element }, index: number) => {
      return elem && <div key={index}>{elem?.component}</div>;
    });

  const handleClick = () => {
    dispatch(reducerGetReport([report.pos.latitude, report.pos.longitude]));
  };

  return (
    <div className="App">
      <Sidebar />
      <SectionContent
        availableButtons={displayedAvailableBtns}
        buttonsContainerRef={buttonsContainerRef}
        headBlockChildren={displayedHeadBtns}
        isOpenGroupBtn={isOpenGroupBtn}
        section="Отчеты"
        pageName="report"
        title={"Отчет №" + id}
      >
        <div className="content__single_report">
          <div className="btns" style={{ margin: "0 0 7px 4px" }}>
            <Link to={`/reports/${id}`} className="tab">
              <div className="buttons__btn --active">Отчет</div>
            </Link>
            {claims?.length > 0 &&
              (claims.includes("admin") || claims.includes("pos:map:view")) && (
                <Link
                  to={"/map"}
                  className="buttons__btn tab__reports_btn"
                  onClick={handleClick}
                >
                  Карта обслуживания
                </Link>
              )}
          </div>
          <UserSingleReport />
        </div>
      </SectionContent>
    </div>
  );
};

export default AdminSingleReportSection;
